<div class="min-h-full pb-28 bg-gray-50 overflow-y-auto w-full mx-auto font-prompt">
    <!-- 1. Header ไล่ระดับสีพรีเมียมโค้งมน -->
    <div
        class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pb-24 pt-8 px-6 rounded-b-[2.5rem] relative z-10 text-white text-left shadow-md w-full h-[200px]">
        <!-- ปุ่มย้อนกลับ -->
        <div class="flex items-center justify-between mb-6">
            <button (click)="goback()"
                class="w-8 h-8 p-2 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 active:scale-90 transition-all outline-none">
                <img src="icons/arrow_back_white.svg" class="w-5 h-5" />
            </button>
            <span
                class="text-[10px] font-bold tracking-wider text-amber-400 bg-amber-500/10 px-3 py-1 rounded-full uppercase">
                {{ cardCode ? (currentLang === "TH" ? "ต่ออายุสมาชิก" : "Renewal") : (currentLang === "TH" ? "สมัครใหม่"
                :
                "Registration") }}
            </span>
        </div>

        <!-- ข้อมูลต้อนรับส่วนตัว -->
        <div class="space-y-1">
            <h1 class="text-lg font-bold leading-tight truncate">
                {{ providerName }}
            </h1>
            <p class="text-[10px] text-amber-400 font-bold">
                {{ currentLang === "TH" ? "การลงทะเบียนสมัครสมาชิกรายเดือน" : "Monthly Pass Membership Registration" }}
            </p>
        </div>
    </div>

    <!-- 2. แผ่นฟอร์มกรอกข้อมูลทับซ้อนส่วนหัว -->
    <div class="px-4 -mt-16 relative z-20 space-y-4 pb-6">

        <!-- CARD 1: วันที่เริ่มต้นใช้งาน -->
        <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
            <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
                <img src="icons/calendar_today_orange.svg" class="w-5 h-5" />
                <h2 class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "วันที่เริ่มต้นใช้งาน" : "Start Date" }}
                </h2>
            </div>

            <p *ngIf="disabled" class="text-[10px] text-gray-400 font-bold leading-none">
                {{ currentLang === "TH" ? "ต้องเริ่มได้หลังจากวันที่" : "Subscription begins after" }}: <span
                    class="text-amber-500">{{ expire_date_show }}</span>
            </p>

            <div class="relative pt-2">
                <label class="absolute -top-2 left-0 bg-white px-1.5 text-[9px] font-bold text-gray-300 leading-none">
                    {{ currentLang === "TH" ? "เลือกได้หลังจากวันที่" : "Available after" }}
                </label>
                <div class="relative">
                    <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" [min]="today"
                        (click)="picker.open()" readonly placeholder="DD/MM/YYYY"
                        class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold cursor-pointer" />
                    <span class=" absolute right-3.5 top-1/2 -translate-y-1/2 pointer-events-none"><img
                            src="icons/date_range_slate.svg" class="w-5 h-5" /></span>
                </div>
                <mat-datepicker #picker panelClass="modern-yellow-datepicker"></mat-datepicker>
            </div>
        </div>

        <!-- CARD 2: ประเภทยานพาหนะ & แพ็คเกจ -->
        <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
            <!-- หัวเรื่องประเภท -->
            <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
                <img src="icons/directions_car_orange.svg" class="w-6 h-6" />
                <h2 class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "ข้อมูลยานพาหนะและแพ็คเกจ" : "Vehicle & Package Info" }}
                </h2>
            </div>

            <!-- ปุ่มประเภทยานพาหนะ -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-2">
                    {{ currentLang === "TH" ? "ประเภทยานพาหนะ" : "Vehicle Type" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <div class="grid grid-cols-2 gap-2">
                    <button *ngFor="let vehicleType of CarOptions" [disabled]="disabled_renew"
                        (click)="handleSelectVehicleType(vehicleType.value)"
                        class="py-2.5 rounded-xl text-sm font-bold transition-all border outline-none active:scale-95 duration-200"
                        [ngClass]="{
              'bg-amber-400 border-amber-400 text-white shadow-md': selectVehicleType === vehicleType.value,
              'bg-gray-50/50 border-gray-100 text-gray-500': selectVehicleType !== vehicleType.value,
              'opacity-60 cursor-not-allowed': disabled_renew && selectVehicleType !== vehicleType.value
            }">
                        {{ vehicleType.label }}
                    </button>
                </div>
            </div>

            <!-- เลือกแพ็คเกจ -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-2">
                    {{ currentLang === "TH" ? "เลือกแพ็คเกจสมาชิก" : "Select Package" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <p *ngIf="!selectVehicleType" class="text-[11px] text-amber-600 mb-1.5">
                    {{ currentLang === "TH"
                    ? "กรุณาเลือกประเภทยานพาหนะก่อน เพื่อแสดงแพ็คเกจที่ถูกต้อง"
                    : "Please select a vehicle type first to show available packages." }}
                </p>
                <div class="relative">
                    <input type="text" [(ngModel)]="packageSearchText" (focus)="onPackageInputFocus()"
                        (blur)="closePackageDropdown()" readonly [disabled]="!selectVehicleType"
                        placeholder="{{ !selectVehicleType
                            ? (currentLang === 'TH' ? 'เลือกประเภทรถก่อน...' : 'Select vehicle type first...')
                            : (currentLang === 'TH' ? 'เลือกแพ็คเกจ...' : 'Select package...') }}"
                        class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold cursor-pointer disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed" />
                    <span class="absolute right-3.5 top-1/2 -translate-y-1/2 pointer-events-none">
                        <img *ngIf="selectVehicleType" src="icons/expand_more_slate_dark.svg" class="w-5 h-5" />
                        <img *ngIf="!selectVehicleType" src="icons/expand_more_slate.svg" class="w-5 h-5" />
                    </span>

                    <!-- Fake Dropdown Menu -->
                    <div *ngIf="showPackageDropdown && selectVehicleType" (mousedown)="$event.preventDefault()"
                        class="absolute left-0 right-0 z-50 bg-white border border-gray-200 rounded-xl shadow-lg mt-1 max-h-60 overflow-y-auto custom-scrollbar">
                        <div *ngFor="let option of filteredPackageOptions" (click)="selectPackage(option)"
                            class="px-4 py-2 text-sm text-gray-700 hover:bg-amber-500/10 hover:text-amber-700 cursor-pointer font-medium transition-colors text-left">
                            {{ option.label }}
                        </div>
                        <div *ngIf="filteredPackageOptions.length === 0"
                            class="px-4 py-3 text-xs text-gray-400 text-center">
                            {{ currentLang === 'TH' ? 'ไม่พบข้อมูลแพ็คเกจ' : 'No packages found' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD 3: ข้อมูลส่วนตัวผู้สมัคร -->
        <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
            <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
                <img src="icons/person_orange.svg" class="w-6 h-6" />
                <h2 class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "ข้อมูลผู้สมัคร" : "Applicant Information" }}
                </h2>
            </div>

            <!-- ชื่อผู้สมัคร -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "ชื่อผู้สมัคร" : "Applicant Full Name" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <input type="text" [(ngModel)]="customer_name"
                    placeholder="{{ currentLang === 'TH' ? 'กรุณากรอกชื่อผู้สมัคร' : 'Enter applicant full name' }}"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold" />
            </div>

            <!-- เบอร์โทร -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "เบอร์โทรศัพท์" : "Contact Phone" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <input type="tel" [disabled]="!disabled" [(ngModel)]="phoneNo"
                    (input)="filterNumberOnly($event); validateForm()" pattern="0[0-9]{9}" maxLength="10"
                    placeholder="0912345678"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed" />
            </div>
        </div>

        <!-- CARD 4: ข้อมูลทะเบียนรถ -->
        <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
            <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
                <img src="icons/badge_orange.svg" class="w-6 h-6" />
                <h2 class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "เลือกป้ายทะเบียนรถที่ต้องการสมัคร" : "Select Vehicle Plates" }}
                </h2>
            </div>

            <!-- กล่องเพิ่มป้ายทะเบียนใหม่ -->
            <div class="flex gap-2">
                <input type="text" [placeholder]="currentLang === 'TH' ? 'ค้นหาทะเบียนรถ...' : 'Search car plate...'"
                    (input)="filterCarPlate($event)"
                    class="w-full max-w-[450px] bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold" />

            </div>
            <button [disabled]="disabled_renew || cardCode === '' || selectVehicleType === '' || !selectVehicleType"
                (click)="toggleModalVehiclePlate(); $event.preventDefault()"
                class="w-full  bg-(--main-color)  hover:bg-slate-700 text-white text-xs font-bold p-1 py-3 rounded-xl transition-all outline-none disabled:bg-slate-500 disabled:opacity-50 disabled:cursor-not-allowed">
                {{ currentLang === "TH" ? "+ เพิ่มทะเบียน" : "+ Add Vehicle Plate" }}
            </button>

            <!-- รายการทะเบียนที่มีให้เลือก -->
            <div
                class="border border-gray-100 rounded-2xl overflow-y-auto h-40 max-h-40 custom-scrollbar divide-y divide-gray-50">
                <!-- สมัครสมาชิกใหม่ (เลือกแช็คบ็อกซ์) -->
                <div *ngIf="!disabled_renew">
                    <div *ngFor="let i of carFilteredPlateList.length > 0 ? carFilteredPlateList : carPlateList"
                        (click)="toggleSelect(i, $event)"
                        class="flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors"
                        [ngClass]="{ 'bg-amber-50/30': isSelected(i.plate_number), 'bg-white hover:bg-gray-50/30': !isSelected(i.plate_number) }">
                        <div class="relative flex items-center justify-center flex-shrink-0 w-5 h-5">
                            <input type="checkbox" [checked]="isSelected(i.plate_number)"
                                (click)="$event.stopPropagation()" (change)="toggleSelect(i, $event)" [ngClass]="{
                                    'bg-amber-400 border-amber-400': isSelected(i.plate_number),
                                    'bg-white border-gray-300': !isSelected(i.plate_number)
                                }"
                                class="appearance-none rounded-md border h-5 w-5 p-1  text-white flex items-center justify-center cursor-pointer transition-all outline-none" />
                            <span *ngIf="isSelected(i.plate_number)" class="absolute pointer-events-none">
                                <img src="icons/check_white.svg" class="w-5 h-5" />
                            </span>
                        </div>
                        <span class="text-sm font-bold text-gray-700">{{ i.plate_number }}</span>
                    </div>
                    <div *ngIf="carPlateList.length === 0"
                        class="text-center py-10 text-[10px] text-gray-400 font-bold">
                        {{ currentLang === 'TH' ? 'ยังไม่มีข้อมูลทะเบียนรถในระบบ' : 'No registered plate numbers' }}
                    </div>
                </div>

                <!-- กรณีเป็นต่ออายุสมาชิก (แสดงเฉยๆ แก้ไขไม่ได้) -->
                <div *ngIf="disabled_renew">
                    <div *ngFor="let i of carFilteredPlateList.length > 0 ? carFilteredPlateList : carPlateList"
                        class="flex items-center gap-3 px-4 py-3 bg-gray-50/40 text-gray-500">
                        <img src="icons/lock_slate.svg" class="w-5 h-5" />
                        <span class="text-sm font-bold">{{ i.plate_number }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD 5: ส่วนลด & ข้อมูลสรุปการชำระเงิน -->
        <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
            <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
                <img src="icons/payments_orange.svg" />
                <h2 class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "ข้อมูลการชำระเงิน" : "Payment & Discount" }}
                </h2>
            </div>

            <!-- กล่องโค้ดส่วนลด -->
            <div class="flex gap-2">
                <input type="text" [disabled]="disableDiscountCode"
                    placeholder="{{ currentLang === 'TH' ? 'รหัสคูปองส่วนลด (ถ้ามี)' : 'Coupon Code (Optional)' }}"
                    [(ngModel)]="discountCode" (ngModelChange)="onChangeDiscountCode($event)"
                    class="flex-1 w-[100px] bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed" />
                <button *ngIf="!disableDiscountCode" (click)="activeCode()"
                    class="bg-amber-400 hover:bg-amber-500 text-white text-xs font-bold px-2 rounded-xl active:scale-95 transition-all outline-none w-[80px]">
                    {{ currentLang === "TH" ? "ใช้สิทธิ์" : "Apply" }}
                </button>
                <button *ngIf="disableDiscountCode" (click)="deleteCode()"
                    class="bg-red-400 hover:bg-red-500 text-white text-xs font-bold px-4 rounded-xl active:scale-95 transition-all outline-none">
                    {{ currentLang === "TH" ? "ยกเลิก" : "Remove" }}
                </button>
            </div>

            <!-- สรุปรายละเอียดการชำระ -->
            <div class="bg-gray-50/50 border border-gray-100 rounded-2xl p-4 space-y-2.5">
                <div class="flex justify-between items-center text-xs font-bold text-gray-500">
                    <span>{{ currentLang === "TH" ? "จำนวนรถที่ระบุ" : "Vehicles count" }}</span>
                    <span class="text-gray-700 text-sm">{{ selectCarPlate ? selectCarPlate.length : 0 }} {{ currentLang
                        === "TH" ?
                        "คัน" : "cars" }}</span>
                </div>

                <div class="flex justify-between items-center text-xs font-bold text-gray-500">
                    <span>{{ currentLang === "TH" ? "อัตราค่าบริการ" : "Unit Rate" }}</span>
                    <span class="text-gray-700 text-sm">{{ fee === 0 || !fee ? "-" : (fee | number) }} {{ currentLang
                        === "TH" ?
                        "บาท" : "THB" }}</span>
                </div>

                <div *ngIf="disableDiscountCode"
                    class="flex justify-between items-center text-xs font-bold text-gray-500">
                    <span>{{ currentLang === "TH" ? "ค่าบริการรวม" : "Subtotal" }}</span>
                    <span class="text-gray-700 text-sm">{{ total | number }} {{ currentLang === "TH" ? "บาท" : "THB"
                        }}</span>
                </div>

                <div *ngIf="disableDiscountCode"
                    class="flex justify-between items-center text-xs font-bold text-red-500">
                    <span>{{ currentLang === "TH" ? "ส่วนลดพิเศษ" : "Coupon Discount" }}</span>
                    <span class="text-sm font-bold">-{{ discountPrice | number }} {{ currentLang === "TH" ? "บาท" :
                        "THB"
                        }}</span>
                </div>

                <div
                    class="border-t border-gray-200/50 pt-2.5 flex justify-between items-center text-sm font-bold text-gray-700">
                    <span>{{ currentLang === "TH" ? "ยอดชำระสุทธิ" : "Total Payment" }}</span>
                    <span class="text-amber-500 text-base font-extrabold">{{ calVehicleTotal() === 0 ? "-" :
                        (calVehicleTotal() |
                        number) }} {{ currentLang === "TH" ? "บาท" : "THB" }}</span>
                </div>
            </div>
        </div>

        <!-- CARD 6: หมายเหตุ & ใบกำกับภาษี -->
        <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
            <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
                <img src="icons/edit_note_slate.svg" />
                <h2 class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "ข้อมูลเพิ่มเติม" : "Additional Information" }}
                </h2>
            </div>

            <!-- หมายเหตุ -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "หมายเหตุการสมัคร" : "Remarks" }}
                </label>
                <textarea rows="3" [(ngModel)]="remarks"
                    placeholder="{{ currentLang === 'TH' ? 'ระบุหมายเหตุความต้องการเพิ่มเติม...' : 'Enter any special notes...' }}"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold resize-none"></textarea>
            </div>

            <!-- สลับขอใบกำกับภาษี -->
            <div class="flex items-center justify-between py-3 border-t border-gray-50">
                <span class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "ต้องการใบกำกับภาษีเต็มรูป" : "Request Full Tax Invoice" }}
                </span>
                <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="isRequestTax" (click)="handleCheckboxTaxChange($event)"
                        class="sr-only peer" />
                    <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-amber-400 transition-colors">
                    </div>
                    <div
                        class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition peer-checked:translate-x-5 shadow-sm">
                    </div>
                </label>
            </div>

            <!-- ปุ่มกรอกใบกำกับเมื่อเลือกไว้ -->
            <div *ngIf="isRequestTax" (click)="toggleModalTaxModal()"
                class="w-full px-4 py-3.5 bg-amber-50/40 hover:bg-amber-50 border border-amber-100 rounded-xl cursor-pointer transition-all flex items-center justify-between text-amber-600 font-bold">
                <div class="flex items-center gap-2">
                    <img src="icons/receipt_long_orange_dark.svg" class="w-5 h-5" />
                    <span class="text-sm">
                        {{ currentLang === "TH" ? "กรอก/แก้ไข ข้อมูลใบกำกับภาษี" : "Tax Invoice Form details" }}
                    </span>
                </div>
                <img src="icons/chevron_right_orange_dark.svg" class="w-5 h-5" />
            </div>
        </div>

        <!-- ปุ่มสมัครหลัก -->
        <div class="pt-4">
            <button type="submit" (click)="submitRequest()"
                class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl py-3.5 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none">
                {{ currentLang === "TH" ? (cardCode ? "ยืนยันต่ออายุสมาชิก" : "สมัครสมาชิกรายเดือน")
                : "Confirm Pass Subscription" }}
            </button>
        </div>

    </div>

</div>

<!------------------------------------------ POPUP MODALS ------------------------------------>

<!-- หน้ากากโหลดดิ้ง -->
<app-pss-loading *ngIf="isLoading || isSaveLoading"></app-pss-loading>

<!-- MODAL 1: กรอกหมายเลขทะเบียนรถยนต์ใหม่ ( showModalVehiclePlate ) -->
<div *ngIf="showModalVehiclePlate"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4 text-left">
    <div
        class="bg-white rounded-[2rem] w-full max-w-sm max-h-[85vh] overflow-y-auto px-6 pt-6 pb-8 shadow-2xl flex flex-col relative animate-scale-up">
        <!-- ปุ่มปิด -->
        <button (click)="toggleModalVehiclePlate()"
            class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
            <img src="icons/close_slate_dark.svg" class="w-5 h-5" />
        </button>

        <!-- หัวข้อ -->
        <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
            {{ currentLang === 'TH' ? 'กรอกหมายเลขทะเบียนรถยนต์' : 'Add Vehicle Plate' }}
        </h2>

        <div class="space-y-4 flex-grow custom-scrollbar">
            <!-- เลขทะเบียน -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === 'TH' ? 'หมายเลขทะเบียน' : 'Plate Number' }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <input type="text" [(ngModel)]="license" (ngModelChange)="validateLicense()"
                    placeholder="{{ currentLang === 'TH' ? 'ระบุทะเบียนรถ (เช่น กข1234)' : 'Specify plate number' }}"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
                <p *ngIf="licenseError" class="text-[9px] font-bold text-red-500 mt-1 leading-none">
                    {{ licenseError }}
                </p>
            </div>

            <!-- เลือกจังหวัด ( autocomplete searchable custom dropdown ) -->
            <div class="relative">
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === 'TH' ? 'จังหวัดป้ายทะเบียน' : 'Province' }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <div class="relative">
                    <input type="text" [(ngModel)]="searchTerm" (focus)="isOpenSelectVehicleProvince = true"
                        placeholder="{{ currentLang === 'TH' ? 'พิมพ์ค้นหาจังหวัด...' : 'Search province...' }}"
                        class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300 cursor-pointer" />
                    <img src="icons/expand_more_slate_dark.svg"
                        class="w-5 h-5 absolute right-3.5 top-1/2 -translate-y-1/2" />
                </div>

                <!-- รายการ dropdown -->
                <div *ngIf="isOpenSelectVehicleProvince" (mousedown)="$event.preventDefault()"
                    class="absolute z-50 left-0 right-0 mt-1 max-h-36 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg scroll-smooth py-1">
                    <div *ngFor="let province of filterProvinces()" (click)="selectProvince(province)"
                        class="px-4 py-2.5 text-sm text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
                        {{ province.value }}
                    </div>
                    <div *ngIf="filterProvinces().length === 0" class="px-4 py-2.5 text-xs text-gray-400 text-center">
                        {{ currentLang === 'TH' ? 'ไม่พบข้อมูลจังหวัด' : 'No provinces found' }}
                    </div>
                </div>
            </div>

            <!-- ปุ่มยืนยัน -->
            <div class="pt-2">
                <button (click)="submitModalVehiclePlate()"
                    class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl py-3 shadow-md transition-all duration-200 active:scale-95 outline-none">
                    {{ currentLang === 'TH' ? 'ยืนยันเพิ่มทะเบียนรถ' : 'Confirm' }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL 2: แบบฟอร์มขอใบกำกับภาษีเต็มรูป ( showTaxModal ) -->
<div *ngIf="showTaxModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4 text-left">
    <div
        class="bg-white rounded-[2rem] w-full max-w-sm max-h-[85vh] overflow-y-auto px-6 pt-6 pb-8 shadow-2xl flex flex-col relative animate-scale-up">
        <!-- ปุ่มปิด -->
        <button (click)="toggleModalTaxModal()"
            class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
            <img src="icons/close_black.svg" class="w-5 h-5" />
        </button>

        <!-- หัวข้อ -->
        <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
            {{ currentLang === 'TH' ? 'ข้อมูลการออกใบกำกับภาษี' : 'Tax Invoice Request Form' }}
        </h2>

        <div class="space-y-4 flex-grow custom-scrollbar">

            <!-- ตัวเลือกประเภท บุคคลธรรมดา / นิติบุคคล -->
            <div class="grid grid-cols-2 gap-2 p-1 bg-gray-100 rounded-xl">
                <button type="button" (click)="selectedTaxType = '1'; filterAddressByTaxType()"
                    class="py-2 text-sm font-bold rounded-lg transition-all outline-none"
                    [ngClass]="selectedTaxType === '1' ? 'bg-amber-400 text-white shadow-sm' : 'bg-transparent text-gray-500 hover:text-gray-700'">
                    {{ currentLang === "TH" ? "บุคคลธรรมดา" : "Individual" }}
                </button>
                <button type="button" (click)="selectedTaxType = '2'; filterAddressByTaxType()"
                    class="py-2 text-sm font-bold rounded-lg transition-all outline-none"
                    [ngClass]="selectedTaxType === '2' ? 'bg-amber-400 text-white shadow-sm' : 'bg-transparent text-gray-500 hover:text-gray-700'">
                    {{ currentLang === "TH" ? "นิติบุคคล" : "Juristic" }}
                </button>
            </div>

            <!-- แสดงที่อยู่สมบูรณ์ที่เลือก (ถ้ามี) -->
            <div *ngIf="showSelectAddress" (click)="toggleModalAddress()"
                class="p-4 bg-amber-50/30 border border-amber-100/50 rounded-2xl cursor-pointer hover:bg-amber-50/50 transition duration-200 flex justify-between items-center">
                <div class="text-left min-w-0 flex-1 pr-3">
                    <span class="text-[9px] text-gray-400 block font-bold leading-none mb-1.5">{{ currentLang === 'TH' ?
                        'ที่อยู่ปัจจุบันที่เลือก' : 'Current Selected Address' }}</span>
                    <p class="text-sm font-bold text-gray-700 truncate">{{ selectedAddress?.full_name }}</p>
                    <p class="text-[10px] text-gray-400 font-bold truncate mt-0.5">{{ selectedAddress?.address }} {{
                        selectedAddress?.sub_district }} {{ selectedAddress?.district }} {{ selectedAddress?.provinces
                        }} {{
                        selectedAddress?.zip_code }}</p>
                </div>
                <img src="icons/chevron_right_slate_dark.svg" class="w-5 h-5" />
            </div>

            <!-- เลขผู้เสียภาษี -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "เลขประจำตัวผู้เสียภาษี" : "Taxpayer ID" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <div class="flex gap-2">
                    <input type="text" [(ngModel)]="taxId" maxLength="13" (input)="filterTaxIdOnly($event)"
                        placeholder="{{ currentLang === 'TH' ? 'ระบุรหัส 13 หลัก' : 'Specify 13-digit ID' }}"
                        class="flex-1 bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
                    <button *ngIf="selectedTaxType === '2'" (click)="getAddressByTaxId()"
                        class="bg-slate-800 hover:bg-slate-700 text-white text-xs font-bold px-4 rounded-xl active:scale-95 transition-all outline-none">
                        {{ currentLang === "TH" ? "ค้นหา" : "Search" }}
                    </button>
                </div>
            </div>

            <!-- สำนักงานใหญ่ ( toggle switch ) สำหรับ นิติบุคคล -->
            <div *ngIf="selectedTaxType === '2'"
                class="flex items-center justify-between py-2.5 border-y border-gray-50">
                <span class="text-sm font-bold text-gray-700">
                    {{ currentLang === "TH" ? "เป็นสำนักงานใหญ่" : "Head Office" }}
                </span>
                <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="mainOffice" class="sr-only peer" />
                    <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-amber-400 transition-colors">
                    </div>
                    <div
                        class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition peer-checked:translate-x-5 shadow-sm">
                    </div>
                </label>
            </div>

            <!-- ชื่อใบกำกับภาษี -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "ชื่อบริษัท / ชื่อผู้เสียภาษี" : "Taxpayer Name" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <input type="text" [(ngModel)]="taxName"
                    placeholder="{{ currentLang === 'TH' ? 'ระบุชื่อภาษาไทย' : 'Specify taxpayer name' }}"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
            </div>

            <!-- เบอร์โทรศัพท์ -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "เบอร์โทรศัพท์ติดต่อ" : "Phone Number" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <input type="text" [(ngModel)]="tax_phone" maxLength="10" (input)="filterTaxPhoneOnly($event)"
                    placeholder="08xxxxxxxx"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
            </div>

            <!-- อีเมล -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "อีเมลผู้เสียภาษี" : "Email" }}
                </label>
                <input type="email" [(ngModel)]="email" placeholder="example@domain.com"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
            </div>

            <!-- ฟิลด์รหัสสาขาเพิ่มเติม (กรณีนิติบุคคล และไม่ได้เลือกเป็นสำนักงานใหญ่) -->
            <div *ngIf="!mainOffice && selectedTaxType === '2'" class="space-y-4 animate-fade-in">
                <div>
                    <label class="block font-bold text-xs text-gray-600 mb-1.5">
                        {{ currentLang === "TH" ? "ชื่อสาขา" : "Branch Name" }}
                    </label>
                    <input type="text" [(ngModel)]="branchName"
                        placeholder="{{ currentLang === 'TH' ? 'เช่น สาขาไอคอนสยาม' : 'Specify branch name' }}"
                        class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
                </div>
                <div>
                    <label class="block font-bold text-xs text-gray-600 mb-1.5">
                        {{ currentLang === "TH" ? "รหัสประจำสาขา" : "Branch Code" }}
                    </label>
                    <input type="text" [(ngModel)]="branchNo" placeholder="0000x"
                        class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
                </div>
            </div>

            <!-- ที่อยู่ -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "รายละเอียดที่อยู่" : "Address" }}
                    <span class="text-red-500 font-bold">*</span>
                </label>
                <input type="text" [(ngModel)]="address"
                    placeholder="{{ currentLang === 'TH' ? 'บ้านเลขที่ ถนน หมู่บ้าน...' : 'House no, Road, Village...' }}"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
            </div>

            <!-- ฟิลด์ที่อยู่ จังหวัด / อำเภอ / ตำบล (Dropdown Selection) -->
            <div class="space-y-4 pt-2">
                <!-- เลือกจังหวัด -->
                <div>
                    <label class="block font-bold text-xs text-gray-600 mb-1.5">
                        {{ currentLang === "TH" ? "จังหวัด" : "Province" }}
                        <span class="text-red-500 font-bold">*</span>
                    </label>
                    <div class="relative">
                        <input type="text" [(ngModel)]="provinceSearchText" (focus)="showProvinceDropdown = true"
                            (blur)="closeProvinceDropdown()"
                            placeholder="{{ currentLang === 'TH' ? 'พิมพ์เลือกจังหวัด...' : 'Type to select province...' }}"
                            class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold" />
                        <img src="icons/expand_more_slate_dark.svg"
                            class="w-5 h-5 absolute right-3.5 top-1/2 -translate-y-1/2" />

                        <!-- Fake Dropdown Menu -->
                        <div *ngIf="showProvinceDropdown" (mousedown)="$event.preventDefault()"
                            class="absolute left-0 right-0 z-50 bg-white border border-gray-200 rounded-xl shadow-lg mt-1 max-h-60 overflow-y-auto custom-scrollbar">
                            <div *ngFor="let province of filteredProvinceOptions"
                                (click)="selectAddressProvince(province)"
                                class="px-4 py-2 text-sm text-gray-700 hover:bg-amber-500/10 hover:text-amber-700 cursor-pointer font-medium transition-colors text-left">
                                {{ province.name_th }}
                            </div>
                            <div *ngIf="filteredProvinceOptions.length === 0"
                                class="px-4 py-3 text-xs text-gray-400 text-center">
                                {{ currentLang === 'TH' ? 'ไม่พบข้อมูลจังหวัด' : 'No provinces found' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- เลือกอำเภอ -->
                <div>
                    <label class="block font-bold text-xs text-gray-600 mb-1.5">
                        {{ currentLang === "TH" ? "อำเภอ / เขต" : "District" }}
                        <span class="text-red-500 font-bold">*</span>
                    </label>
                    <div class="relative">
                        <input type="text" [(ngModel)]="amphureSearchText" (focus)="showAmphureDropdown = true"
                            (blur)="closeAmphureDropdown()" [disabled]="selectedProvinceId === null"
                            placeholder="{{ currentLang === 'TH' ? 'พิมพ์เลือกอำเภอ...' : 'Type to select district...' }}"
                            class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold disabled:opacity-60 disabled:cursor-not-allowed" />
                        <img src="icons/expand_more_slate_dark.svg"
                            class="w-5 h-5 absolute right-3.5 top-1/2 -translate-y-1/2" />

                        <!-- Fake Dropdown Menu -->
                        <div *ngIf="showAmphureDropdown && selectedProvinceId !== null"
                            (mousedown)="$event.preventDefault()"
                            class="absolute left-0 right-0 z-50 bg-white border border-gray-200 rounded-xl shadow-lg mt-1 max-h-60 overflow-y-auto custom-scrollbar">
                            <div *ngFor="let amphure of filteredAmphureOptions" (click)="selectAmphure(amphure)"
                                class="px-4 py-2 text-sm text-gray-700 hover:bg-amber-500/10 hover:text-amber-700 cursor-pointer font-medium transition-colors text-left">
                                {{ amphure.name_th }}
                            </div>
                            <div *ngIf="filteredAmphureOptions.length === 0"
                                class="px-4 py-3 text-xs text-gray-400 text-center">
                                {{ currentLang === 'TH' ? 'ไม่พบข้อมูลอำเภอ' : 'No districts found' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- เลือกตำบล -->
                <div>
                    <label class="block font-bold text-xs text-gray-600 mb-1.5">
                        {{ currentLang === "TH" ? "ตำบล / แขวง" : "Subdistrict" }}
                        <span class="text-red-500 font-bold">*</span>
                    </label>
                    <div class="relative">
                        <input type="text" [(ngModel)]="tambonSearchText" (focus)="showTambonDropdown = true"
                            (blur)="closeTambonDropdown()" [disabled]="selectedAmphureId === null"
                            placeholder="{{ currentLang === 'TH' ? 'พิมพ์เลือกตำบล...' : 'Type to select subdistrict...' }}"
                            class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold disabled:opacity-60 disabled:cursor-not-allowed" />
                        <img src="icons/expand_more_slate_dark.svg"
                            class="w-5 h-5 absolute right-3.5 top-1/2 -translate-y-1/2" />

                        <!-- Fake Dropdown Menu -->
                        <div *ngIf="showTambonDropdown && selectedAmphureId !== null"
                            (mousedown)="$event.preventDefault()"
                            class="absolute left-0 right-0 z-50 bg-white border border-gray-200 rounded-xl shadow-lg mt-1 max-h-60 overflow-y-auto custom-scrollbar">
                            <div *ngFor="let tambon of filteredTambonOptions" (click)="selectTambon(tambon)"
                                class="px-4 py-2 text-sm text-gray-700 hover:bg-amber-500/10 hover:text-amber-700 cursor-pointer font-medium transition-colors text-left">
                                {{ tambon.name_th }}
                            </div>
                            <div *ngIf="filteredTambonOptions.length === 0"
                                class="px-4 py-3 text-xs text-gray-400 text-center">
                                {{ currentLang === 'TH' ? 'ไม่พบข้อมูลตำบล' : 'No subdistricts found' }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- รหัสไปรษณีย์ -->
                <div>
                    <label class="block font-bold text-xs text-gray-600 mb-1.5">
                        {{ currentLang === "TH" ? "รหัสไปรษณีย์" : "Postal Code" }}
                    </label>
                    <input type="text" [(ngModel)]="zipcode" readonly
                        class="w-full bg-gray-100 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-400 outline-none cursor-not-allowed font-bold" />
                </div>
            </div>

            <!-- ปุ่มบันทึก -->
            <div class="pt-2">
                <button (click)="submitTax()"
                    class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl py-3 shadow-md transition-all duration-200 active:scale-95 outline-none">
                    {{ currentLang === "TH" ? "บันทึกข้อมูลใบกำกับภาษี" : "Save Details" }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL 3: กล่องแจ้งเตือนการต่ออายุสมาชิก ( isModalRenewWarn ) -->
<div *ngIf="isModalRenewWarn"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4 text-center">
    <div
        class="bg-white rounded-[2rem] w-full max-w-xs px-6 py-6 shadow-2xl flex flex-col justify-center items-center relative animate-scale-up">
        <!-- ภาพ Sticker -->
        <div class="w-24 h-24 flex justify-center items-center mb-3">
            <img src="icons/PSS/PSS Sticker-07.png" alt="warn" class="w-full h-full object-contain" />
        </div>

        <!-- ข้อความ -->
        <h3 class="text-base font-extrabold text-gray-800 mb-2">
            {{ currentLang === "TH" ? "การต่ออายุสมาชิกรายเดือน" : "Pass Renewal" }}
        </h3>
        <p class="text-sm text-gray-500 font-medium leading-snug mb-3">
            {{ currentLang === "TH" ? "การต่ออายุสมาชิกจะไม่สามารถแก้ไขบางข้อมูลบนระบบได้" : "Some pass settings cannot
            be
            changed during active pass renewal." }}
        </p>
        <p class="text-[10px] text-red-500 font-bold leading-normal mb-4">
            {{ currentLang === "TH" ? "* หากต้องการใบกำกับภาษีกรุณากดเพื่อเรียกรับ !" : "* Click request if you require
            full
            tax receipt invoice !" }}
        </p>

        <!-- ปุ่มเลือก -->
        <div class="flex gap-2 w-full">
            <button (click)="isModalRenewWarn = false;"
                class="flex-1 bg-amber-400 hover:bg-amber-500 text-white text-xs font-bold rounded-xl py-2.5 active:scale-95 transition-all outline-none">
                {{ currentLang === "TH" ? "ขอใบกำกับ" : "Request Receipt" }}
            </button>
            <button (click)="handleCheckboxTaxChange($event); isModalRenewWarn = false"
                class="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-600 text-xs font-bold rounded-xl py-2.5 active:scale-95 transition-all outline-none">
                {{ currentLang === "TH" ? "ไม่ต้องการ" : "Decline" }}
            </button>
        </div>
    </div>
</div>

<!-- MODAL 4: กล่องเลือกป้ายทะเบียนจากรายการเดิมที่มีอยู่แล้ว ( modalSelectVehicle ) -->
<div *ngIf="modalSelectVehicle"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4 text-left">
    <div
        class="bg-white rounded-[2rem] w-full max-w-sm max-h-[80vh] overflow-y-auto px-6 pt-6 pb-8 shadow-2xl flex flex-col relative animate-scale-up">
        <!-- ปุ่มปิด -->
        <button (click)="modalSelectVehicle = false"
            class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
            <img src="icons/close_black.svg" class="w-5 h-5" />
        </button>

        <!-- หัวข้อ -->
        <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
            {{ currentLang === 'TH' ? 'เลือกป้ายทะเบียนรถยนต์' : 'Select Registered Vehicle' }}
        </h2>

        <!-- รายการ -->
        <div class="space-y-2 flex-grow overflow-y-auto max-h-[50vh] custom-scrollbar divide-y divide-gray-50">
            <div *ngFor="let vehicle of licenseAll" (click)="changeLicense(vehicle.plate_number)"
                class="p-3 bg-gray-50/50 hover:bg-amber-50/40 border border-gray-100 rounded-xl cursor-pointer transition-all flex items-center justify-between">
                <div>
                    <p class="text-sm font-bold text-gray-700 leading-snug">{{ vehicle.plate_number }}</p>
                    <p class="text-[9px] text-gray-400 font-bold capitalize mt-0.5">{{ vehicle.vehicle_type_name }}</p>
                </div>
                <img src="icons/check_circle_slate.svg" class="w-5 h-5" />
            </div>
            <div *ngIf="licenseAll.length === 0" class="text-center py-10 text-[10px] text-gray-400 font-bold">
                {{ currentLang === 'TH' ? 'ไม่มีรถจดทะเบียนในระบบ' : 'No plate history registered' }}
            </div>
        </div>
    </div>
</div>

<!-- MODAL: เลือกที่อยู่ที่บันทึกไว้ ( showAddressModal ) -->
<div *ngIf="showAddressModal"
    class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
    <div
        class="bg-white rounded-[2rem] w-full max-w-sm max-h-[80vh] overflow-y-auto p-6 shadow-2xl relative animate-scale-up custom-scrollbar flex flex-col">
        <button (click)="showAddressModal = false"
            class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
            <img src="icons/close_black.svg" class="w-5 h-5" />
        </button>
        <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
            {{ currentLang === 'TH' ? 'เลือกที่อยู่' : 'Select Address' }}
        </h2>

        <div class="space-y-2 flex-grow overflow-y-auto custom-scrollbar">
            <div *ngFor="let item of filteredAddressList" (click)="selectAddress(item)"
                class="p-3 bg-white border border-gray-100 rounded-2xl cursor-pointer hover:border-amber-200 hover:bg-amber-50/10 transition-all text-xs text-gray-800 shadow-sm group">
                <div
                    class="font-bold text-xs text-gray-900 mb-1 group-hover:text-amber-600 transition-colors flex items-center justify-between">
                    <span>{{ item.full_name }}</span>
                    <span *ngIf="item.headquarters"
                        class="inline-flex items-center gap-1 bg-green-50 text-green-600 text-[9px] font-bold px-2 py-0.5 rounded-full">
                        {{ currentLang === 'TH' ? 'สำนักงานใหญ่' : 'Head Office' }}
                    </span>
                </div>
                <div class="text-[11px] text-gray-500 font-medium leading-relaxed">
                    <span *ngIf="item.company_name" class="block font-semibold text-gray-700">{{ item.company_name }}</span>
                    {{ item.address }} {{ item.sub_district }} {{ item.district }} {{ item.provinces }} {{ item.zip_code }}
                </div>
                <div *ngIf="item.email" class="text-[10px] text-gray-400 mt-1 flex items-center gap-1">
                    <img src="icons/mail_slate.svg" class="w-3 h-3" />
                    {{ item.email }}
                </div>
            </div>

            <div *ngIf="filteredAddressList.length === 0" class="py-8 text-center text-xs text-gray-400">
                {{ currentLang === 'TH' ? 'ไม่พบข้อมูลที่อยู่' : 'No addresses found' }}
            </div>
        </div>
    </div>
</div>

<!-- ยืนยันการทำรายการลงทะเบียน -->
<app-pss-warn *ngIf="showModal_confirm"
    [text]="disabled ? (currentLang === 'TH' ? 'ต่ออายุสมาชิก' : 'Renew Pass') : (currentLang === 'TH' ? 'สมัครสมาชิก' : 'Register Pass')"
    [detail]="(currentLang === 'TH'
    ? 'กรุณาตรวจสอบข้อมูลการลงทะเบียนให้ถูกต้อง หากทำการยืนยันแล้วจะไม่สามารถกลับมาแก้ไขข้อมูลทีหลังได้ (ยกเว้นติดต่อเจ้าหน้าที่)'
    : 'Please verify registration details before confirming. Pass subscription details cannot be edited later once submitted.')"
    [language]="currentLang" [isButtonConfirm]="true" (close)="closeModal_Confirm()"
    (submit)="saveMemberRegister()"></app-pss-warn>
